<template>
    <b-modal v-model="modal_upload.show"
             hide-footer
             centered
             title="Creación masiva"
    >
        <b-form @submit.prevent="validateForm()"
                data-vv-scope="upload"
        >
            <b-row>
                <b-col cols="12">
                    <b-form-file id="file"
                                 name="file"
                                 v-model="upload.file"
                                 accept=".xlsx"
                                 data-vv-as=" "
                                 v-validate="'required|mimes:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                                 data-vv-delay="1000"
                                 placeholder="Elija un archivo o suéltelo aquí..."
                                 drop-placeholder="Suelta el archivo aquí..."
                    />
                    <span class="text-danger small"
                          v-text="errors.first('upload.file')"
                    />
                </b-col>
            </b-row>

            <b-row>
                <div class="w-100 text-center">
                    <hr/>

                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="validateForm()"
                    >
                        <i class="fa fa-save"/> Guardar
                    </b-btn>
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="setShowToModalUpload(false)"
                    >
                        <i class="fa fa-close"/> Cancelar
                    </b-btn>
                </div>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('areas', [
            'upload',
            'modal_upload'
        ])
    },
    methods: {
        ...mapActions('areas', [
            'uploadAndMassiveCreate',
            'fetchAreas'
        ]),
        ...mapMutations('areas', [
            'setShowToModalUpload',
        ]),
        validateForm() {
            this.$validator.validateAll('upload')
                .then(async (result) => {
                    if (result) {
                        await this.uploadAndMassiveCreate();
                        this.setShowToModalUpload(false);
                        await this.fetchAreas();
                    }
                });
        }
    },
};
</script>

<style scoped>
</style>
